<template>
	<div v-if="displayPaymentMethodControl()" class="field payment-method" role="radiogroup" aria-label="Payment Options">
		<BaseRadio
			:name="payLaterTitle()"
			:activeClass="isPayLaterActive()"
			:click="handlePayLaterClick"
			ariaLabel="Pay later in person"
			:aria-checked="(isPayLater)"
			v-if="displayPayLaterButton()" />
		<BaseRadio
			:name="payNowTitle()"
			:activeClass="isPayNowActive()"
			:click="handlePayNowClick"
			ariaLabel="Pay now online"
			:aria-checked="(isPayNow)"
			v-if="displayPayNowButton()" />
	</div>
</template>

<script>
	import paymentMixin from '@Mixin/paymentMixin';
	import { EServiceType } from '@/models/interfaces/Orders/EServiceType';
	import { EPreorder } from '@/services/order.service';
	import serviceMixin from '@Mixin/serviceMixin';
	import { ACCOUNT_CHECKOUT } from '@/stores/defs';
	import { mapGetters } from 'vuex';
	
	export default {
		mixins: [
			paymentMixin,
			serviceMixin,
		],
		computed: {
			...mapGetters({
				getLeaveAtDoor: ACCOUNT_CHECKOUT.GET_LEAVE_AT_DOOR,
			}),
		},
		methods: {
			displayPaymentMethodControl() {
				return true;
			},
			// Pay now
			displayPayNowButton() {
				return true;
			},
			payNowTitle() {
				return 'Pay now with debit or credit card';
			},
			isPayNowActive() {
				return (this.isPayNow) ? 'selected' : '';
			},
			handlePayNowClick(event) {
				this.setPreorder(EPreorder.PAY_NOW);
				this.$tpa.trackCheckoutPaymentMethod('Pay Online');
			},
			handlePayLaterClick(event) {
				this.setPreorder(EPreorder.PAY_LATER);
				this.$tpa.trackCheckoutPaymentMethod('Pay Later');
			},
			// Pay later
			displayPayLaterButton() {
				const methods = this.$appConstants.payment.methods;
				const findPayLater = methods.find((method) => {
					return (method.value === EPreorder.PAY_LATER);
				});
				if (!findPayLater || this.getLeaveAtDoor) {
					return false;
				}
				return true;
			},
			payLaterTitle() {
				let payLaterTxt = 'Pay in person';
				
				if (this.serviceType === EServiceType.SERVICE_TYPE_DELIVERY) {
					payLaterTxt = "Pay with cash upon delivery";
				} else if (this.serviceType === EServiceType.SERVICE_TYPE_TAKEOUT) {
					payLaterTxt = "Pay at store"
				}
				return payLaterTxt;
			},
			isPayLaterActive() {
				return (this.isPayLater) ? 'selected' : '';
			},
		},
		mounted() {
			this.setDefaultPaymentMethod();
		}
	}
</script>

<style lang="scss">

.payment-method {
	.option-choice-name {
		max-width: 100% !important;
	}
}

</style>


// WEBPACK FOOTER //
// src/components/checkout/PaymentMethodControl.vue